/**
 * The tank drawing family — the ids `TankAnimation.vue` draws.
 *
 * The hub declares `settings.tank_type` on its cistern and waste-plant classes; a
 * device saved before that keeps the choice in its icon/class/name, which
 * `tankKindOf` still reads.
 */
import { tankKindOf } from '../../devices/deviceWidgetTypes';
import { variantFromSetting, variantValues, type VariantFamily } from './types';

export const TANK_VARIANTS: VariantFamily = {
  drawing: 'tank',
  settingKey: 'tank_type',
  title: ['Tank type', 'Vrsta rezervoarja'],
  description: [
    'The vessel this tank is. The tile draws it, filled to the level it reports.',
    'Vrsta tega rezervoarja. Ploščica ga nariše, napolnjenega do prijavljene gladine.',
  ],
  options: [
    { value: 'auto', icon: 'settings_suggest', label: ['Automatic', 'Samodejno'] },
    { value: 'ibc', icon: 'package_2', label: ['IBC tote', 'IBC kontejner'] },
    { value: 'cistern', icon: 'propane_tank', label: ['Cistern', 'Cisterna'] },
    { value: 'horizontal', icon: 'water_bottle_large', label: ['Horizontal cistern', 'Ležeča cisterna'] },
    { value: 'buffer', icon: 'water_heater', label: ['Buffer tank', 'Hranilnik tople vode'] },
    { value: 'treatment', icon: 'water_damage', label: ['Treatment plant', 'Čistilna naprava'] },
    { value: 'septic', icon: 'foundation', label: ['Septic tank', 'Greznica'] },
    { value: 'expansion', icon: 'compress', label: ['Expansion vessel', 'Raztezna posoda'] },
  ],
  defaultValue: 'auto',
  resolve: (device) => variantFromSetting(device.settings, 'tank_type', variantValues(TANK_VARIANTS)) ?? tankKindOf(device),
};
